import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createBundleUsage } from "../services/create-bundle-usage";
import { CreateBundleUsageRequest } from "@/pages/users/types/bundle-usage";

export function useCreateBundleUsage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateBundleUsageRequest) => createBundleUsage(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"] });
    },
  });
}
